/**
 * @generated SignedSource<<e5a90fbb8fbd1e7609d1293571498c6c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamFeatureBarKPIItem_KPITeamFeature$data = {
  readonly KPIRoutines: ReadonlyArray<{
    readonly occasions: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly occasionSections: ReadonlyArray<{
            readonly id: string;
            readonly taskExecutions: ReadonlyArray<{
              readonly isCompleted?: boolean;
            }>;
          }>;
        };
      }>;
    };
  }>;
  readonly " $fragmentType": "TeamFeatureBarKPIItem_KPITeamFeature";
};
export type TeamFeatureBarKPIItem_KPITeamFeature$key = {
  readonly " $data"?: TeamFeatureBarKPIItem_KPITeamFeature$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamFeatureBarKPIItem_KPITeamFeature">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "teamId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamFeatureBarKPIItem_KPITeamFeature",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Routine",
      "kind": "LinkedField",
      "name": "KPIRoutines",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 1
            }
          ],
          "concreteType": "RoutineOccasionConnection",
          "kind": "LinkedField",
          "name": "occasions",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RoutineOccasionEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RoutineOccasion",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": [
                        {
                          "kind": "Variable",
                          "name": "teamId",
                          "variableName": "teamId"
                        }
                      ],
                      "concreteType": "RoutineOccasionSection",
                      "kind": "LinkedField",
                      "name": "occasionSections",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "id",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": null,
                          "kind": "LinkedField",
                          "name": "taskExecutions",
                          "plural": true,
                          "selections": [
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "isCompleted",
                                  "storageKey": null
                                }
                              ],
                              "type": "TaskExecutionNumber",
                              "abstractKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "occasions(first:1)"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "KPITeamFeature",
  "abstractKey": null
};

(node as any).hash = "c9f988646deedde480b0fae7806f25c3";

export default node;
